// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"bdb84141","886":"3b7cedd5","904":"ff5ead6f"}[chunkId] + ".chunk.css";
};